import React, { useEffect, useState } from 'react'
import NotificationService from "../../services/Notification";
import { SingleWhatsappLogRow } from '../../components/List/SingleWhatsappLogRow';

export const WhatsappLogList = () => {
  const [list, setList] = useState<any>([]);
  const fetchData = async () => {
    NotificationService.getWhatsappLogs()
      .then((res: any) => {
        setList(res.data);
      })
      .catch((error: any) => {
        console.log(error);
      });
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      <div className="main-wrapper">
        <div className="page_title py-2">
          Notifications - Whatsapp Notification Logs
        </div>
        <div className="p-4">
          {/* Main secttion */}
          <div className="main-section">
            <table className="table">
              <thead>
                <tr>
                  <th>Template Name</th>
                  <th>Phone Numbers</th>
                  <th>Status</th>
                  <th>Source</th>
                  <th>Scheduled Date</th>
                  <th>Scheduled Time</th>
                  <th>Trigger Date</th>
                  <th>Trigger Time</th>
                  {/* <th>Action</th> */}
                </tr>
              </thead>
              <tbody>
                {list && list.length > 0 ? (
                  list.map((el: any) => (
                    <SingleWhatsappLogRow key={el._id} props={el} />
                  ))
                ) : (
                  <h1 className="no-data">No Data Found</h1>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
